import { Fragment } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import Authorized from '@/components/Authorized';
import DraftCompetition from '@/components/Competition/DraftCompetition';
import { classes } from '@/util/component-utils';
import styles from './draftcompetition.module.css';

const route = '/draftcompetition/$competitionId';
export const Route = createFileRoute(route)({
  component: DraftCompetitionPage,
})

const logRoute = () => {
  console.log("Draft competition route");
}

function DraftCompetitionPage() {
  const { competitionId } = useParams({ from: route });
  logRoute();

  return (
    <Fragment>
      <Authorized>
        <div className={classes("scrolling-container", styles.draftCompetitionContainer)}>
          <DraftCompetition competitionId={competitionId} />
        </div>
      </Authorized>
    </Fragment>
          
  )
}
